import { fetchClient } from 'api/firestore/managementData';
import { useAuthInfo } from 'auth';

export const useClientGet = () => {
  const { currentUser } = useAuthInfo();
  const getClientInfo = (id: number) => fetchClient(currentUser, id);

  return { getClientInfo };
};
